<template>
    <div>
        <ds-table-grid
            ref="table"
            :data="referalPartners"
            align="center"
            data-qa="referral-list-table"
            class="referral-list-table"
            :click-row="editReferral"
        >
            <ds-table-grid-column
                label="Referral Partner"
                width="200"
                prop="referralPartner"
                data-qa="edit-referral"
            >
                <template slot-scope="item">
                    <span class="current-referral">{{ item.referralPartner }}</span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Type"
                width="100"
                prop="type"
            >
                <template slot-scope="item">
                    <span class="current-referral">{{ item.type }}</span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Date added"
                width="180"
                prop="dateSet"
            >
                <template slot-scope="item">
                    <span class="current-referral">{{ item.dateSet }}</span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="IP address"
                width="150"
                prop="iPAddress"
            >
                <template slot-scope="item">
                    <span :class="item.iPAddress ? 'current-referral' : 'current-referral disabled-text'"> {{ item.iPAddress ? item.iPAddress : 'none' }} </span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Expiration"
                width="130"
                prop="dateExpires"
            >
                <template slot-scope="item">
                    <span class="current-referral"> {{ item.dateExpires ? item.dateExpires : 'No Expiration' }} </span>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="Source"
                width="150"
                prop="source"
            >
                <template slot-scope="item">
                    <span :class="item.source? 'current-referral source' : 'current-referral source disabled-text'"> {{ item.source ? item.source : 'none' }} </span>
                </template>
            </ds-table-grid-column>
        </ds-table-grid>
    </div>
</template>

<script>
export default {
    props: {
        referalPartners: Array,
    },

    methods: {
        editReferral(item) {
            this.$emit('editReferral', item);
        },
    },
};
</script>

<style lang="scss" scoped>
    .source {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        display: block;
    }

    .disabled-text {
        opacity: 0.5;
    }
</style>
